import { AxiosAPI } from './AxiosApi';
class AuthApi extends AxiosAPI {
    createSession = async (options = {}) => {
        return await this.POST(this.apiSchema.POST.auth.session(), {}, options);
    };
    removeSession = async (options = {}) => {
        return await this.DELETE(this.apiSchema.DELETE.auth.session(), options);
    };
}
export default new AuthApi();
